import { z } from 'zod';

/**
 * Billing lifecycle status (Hero-side flow — simpler than freight Invoice).
 *
 * - `draft`           — built but not finalized (admin can edit)
 * - `pending`         — finalized, awaiting payment
 * - `partially_paid`  — at least one BTx succeeded but total not covered
 * - `paid`            — fully paid
 * - `past_due`        — overdue (dueDate < now and not paid)
 * - `cancelled`       — voided before payment
 * - `refunded`        — fully refunded
 */
export const billingStatusSchema = z.enum([
  'draft',
  'pending',
  'partially_paid',
  'paid',
  'past_due',
  'cancelled',
  'refunded',
]);
export type BillingStatus = z.infer<typeof billingStatusSchema>;
